import React from "react";
import Post from "./Post2";
import Comments from "../Comment/Comments";
import RightPanel from "../RightPanel/RightPanel";
import LeftPanel from "../LeftPanel/LeftPanel";
import SearchView from "../Search/SearchView";
import { useEffect, useState } from "react";
import GoogleAd from "../Adsense/GoogleAd";
import useViewport from "../Utils/useViewPort"
import MobilePost from "./MobilePost";
import ReloadModal from "../modal/ReloadModal";

export const MainContent = (props) => {
  // const isMobile = useMediaQuery({ query: "(max-width: 760px)" });
  // const isDesktopOrLaptop = useMediaQuery({
  //   query: '(min-width: 1224px)'
  //   })
  //   const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  //   const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  //   const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  //   const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  const viewPort = useViewport();
  const isMobile = viewPort.width <= 1024;
  const post = props.post;
  const content = props.content;
  const slug = props.slug;
  const apiError = props.apiError

  const [user, setUser] = useState();
  const [leftDisp, setLeftDisp] = useState("block");
  const [rightDisp, setRightDisp] = useState("block");
  const [leftVis, setLeftVis] = useState("hidden");
  const [rightVis, setRightVis] = useState("hidden");
  // const [pload, setPload] = useState(false);


  useEffect(() => {
    var tmp = localStorage.getItem("user", null);
    if (tmp !== "undefined" && tmp != null) {
      setUser(JSON.parse(tmp).username);
    }
  }, []);



  return (
    <>
      {/* {!isMobile &&<LeftPanel changeVis={setLeftLoaded} slug={props.slug} />} */}
      <div
        style={{
          gridArea: "MainContent",
          gridColumn: "6/30",
          paddingLeft: isMobile ? "10px" : 0,
          paddingRight: isMobile ? "10px" : 0,
          marginRight: isMobile ? "10px" : "30px",
          maxWidth:"100%",
          width:"100%",
        }}
      >
        {post ? <> {post}</> : <>{!content ? <SearchView /> : content}</>}
        {isMobile &&  <GoogleAd
          classNames="GoogAd"
          slot="1622775764"
          googleAdId="ca-pub-3156532081104759"
        />}
        {post ? ( props.pload &&
          <Comments
            commentsUrl="http://localhost:3004/comments"
            currentUserId={user}
            slug={slug}
          />
        ) : (
          <></>    
        )}
        <ReloadModal isShowing={apiError} hide={(index) => this.toggle(this.state.modalIndex)} />
      </div>
      {/* {!isMobile && <RightPanel changeVis = {setRightLoaded}/>} */}
    </>
  );
};
